import {
  CarrierType,
  CarrierVisitDirection,
  CarrierVisitResponse,
  CarrierVisitStatus,
  JourneyResponse,
} from '@yard/app/api'
import dayjs, { Dayjs } from 'dayjs'

export function filterCarrierVisits(
  visits: CarrierVisitResponse[],
  selectedDate?: Dayjs,
  selectedTypes?: CarrierType[],
  selectedStatus?: CarrierVisitStatus[],
): CarrierVisitResponse[] {
  return visits.filter(cv => {
    if (!(cv.eta || cv.ata)) return false
    if (selectedDate) {
      const visitDate = dayjs(cv.ata || cv.eta)
      const isOpenVisit =
        cv.status === CarrierVisitStatus.Expected ||
        cv.status === CarrierVisitStatus.Arrived ||
        cv.status === CarrierVisitStatus.InOperation

      if (visitDate.isBefore(dayjs()) && !isOpenVisit) {
        return false
      }

      if (visitDate.isAfter(selectedDate)) {
        return false
      }
    }

    if (selectedTypes?.length && !selectedTypes.includes(cv.carrierType)) return false
    if (selectedStatus?.length && !selectedStatus.includes(cv.status)) return false
    return true
  })
}

export function getVisitJourneys(
  journeys: JourneyResponse[],
  visit: CarrierVisitResponse,
  direction: CarrierVisitDirection,
): JourneyResponse[] {
  if (direction === CarrierVisitDirection.Inbound) {
    return journeys.filter(
      journey =>
        journey.inboundCarrierVisitId === visit.id &&
        journey.inboundCarrierType === visit.carrierType,
    )
  } else {
    return journeys.filter(
      journey =>
        journey.outboundCarrierVisitId === visit.id &&
        journey.outboundCarrierType === visit.carrierType,
    )
  }
}
